import { default as MuiTableHead, TableHeadProps } from '@mui/material/TableHead'
import * as React from 'react'

const TableHead: React.FC<React.PropsWithChildren<TableHeadProps>> = (props) => <MuiTableHead {...props} />

export default TableHead
